const mock = {
  view: ["1D", "1S", "15D", "1M"],
  prevision: ["30min", "1D", "1S"]
};

export default mock;
